import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { ComponentModule } from "src/app/components/component.module";
import { RecentlyPlayedGameComponent } from "../../components/recently-played-game/recently-played-game.component";
import { TrendingGameComponent } from "../../components/trending-game/trending-game.component";
import { GameBlogComponent } from "./game-blog/game-blog.component";
import { GamesRePayableComponent } from "./games-re-playable/games-re-playable.component";
import { GamesPage } from "./games.page";
import { InstantWinGameComponent } from "./instant-win-game/instant-win-game.component";
import { SkillGameComponent } from "./skill-game/skill-game.component";
import { GamePreDetailsPopupComponent } from "./yours-to-play-popup/yours-to-play-popup.component";


import { HttpClient } from "@angular/common/http";
import { AuthService } from "@core/auth.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { GamePlayComponent } from "src/app/components/game-play/game-play.component";
import { FirestoreTransLoader } from "src/app/services/firestore.service";
import { SwiperModule } from "swiper/angular";
import { AdventureGameComponent } from "./adventure-game/adventure-game.component";
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }
export function FirestoreTranslationsLoaderFactory(http: HttpClient, authService: AuthService) {
  return new FirestoreTransLoader(http);
}

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        component: GamesPage,
      },
      {
        path: "skill-game/:id",
        component: SkillGameComponent,
      },
      {
        path: "instant-win-game/:id",
        component: InstantWinGameComponent,
      },
      {
        path: "game-blog/:index",
        component: GameBlogComponent,
      },
      {
        path: "replayable/:id",
        component: GamesRePayableComponent,
      },
      {
        path: "gamePlay",
        component: GamePlayComponent,
      },
      {
        path: "adventure-game/:id",
        component: AdventureGameComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentModule,
    SwiperModule,
    RouterModule.forChild(routes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: FirestoreTranslationsLoaderFactory,
        deps: [HttpClient, AuthService],
      },
      defaultLanguage: "en",
    }),
    GamesPage,
    SkillGameComponent,
    InstantWinGameComponent,
    GameBlogComponent,
    GamePreDetailsPopupComponent,
    RecentlyPlayedGameComponent,
    TrendingGameComponent,
    GamesRePayableComponent,
    AdventureGameComponent,
  ],
})
export class GamesPageModule { }
